// @flow

import { mapSourceOfFundsKeys } from "buba-components/src/views/Details/mappers";

import { generateDescriptionList } from "../generateDescriptionList";

import styles from "../BankInquiryApplication.scss";

type GeneralDataProps = {
  data: any
};

const GeneralData = ({ data }: GeneralDataProps) => {
  // Create configuration object for the description list
  const descriptionListConfig = {
    sections: [
      // Company section
      {
        title: "Unternehmen",
        items: [
          {
            label: "Name",
            data: data.details.company?.name
          },
          {
            label: "Rechtsform",
            data: data.details.company?.legalForm
          },
          {
            label: "Anschrift",
            data: data.details.company?.address
          },
          {
            label: "Ort",
            data: data.details.company?.zipPlusCity
          },
          {
            label: "Gründungsdatum",
            data: data.details.company?.foundationDate
          }
        ]
      },
      // Project section
      {
        title: "Vorhaben",
        items: [
          {
            label: "Art des Vorhabens",
            data: data.details.project?.type,
            fullWidth: true
          },
          {
            label: "Beschreibung",
            data: data.details.project?.description,
            fullWidth: true
          }
        ]
      },
      // Use of funds section
      {
        title: "Mittelverwendung",
        items:
          data.details.project?.useOfFunds?.flatMap(item => [
            {
              label: "Investitionselement",
              data: item.type
            },
            {
              label: "Betrag",
              data: item.amount
            }
          ]) || []
      },
      // Source of funds section
      {
        title: "Mittelherkunft",
        items:
          data.details.project?.sourceOfFunds?.flatMap(item => [
            {
              label: "Finanzierungselement",
              data: mapSourceOfFundsKeys(item.type)
            },
            {
              label: "Betrag",
              data: item.amount
            }
          ]) || []
      },
      // Collaterals section
      {
        title: "Sicherheiten",
        items:
          // eslint-disable-next-line no-unused-vars
          Object.entries(data.details.inquiry?.collaterals)?.flatMap(([_, item]) => [
            {
              label: "Bezeichnung",
              data: item.kind
            },
            {
              label: "Betrag",
              data: item.value
            }
          ]) || []
      }
    ]
  };

  return generateDescriptionList(descriptionListConfig, styles.descriptionList);
};

export default GeneralData;
